export default __webpack_public_path__ + "static/media/app-store-logo.72375815.svg";